var exports = {
  "kL": "xdbfd91f1--f983f7--container",
  "DP": "xdbfd91f1--f983f7--container-mobile",
  "_r": "xdbfd91f1--f983f7--text_container",
  "Qq": "xdbfd91f1--f983f7--text",
};

module.exports = exports;
